/**
 * Node-role colors passed to `NodeIcon` as raw CSS values.
 *
 * NodeIcon's `color` prop accepts any CSS color string (runtime-resolved), so
 * these need to be literal hex values rather than Tailwind classes. They
 * mirror the Figma `ds-*` status palette:
 *
 *   action  → green-500      (#22c55e — green node)
 *   trigger → ds-focus-brand  (#2450ff — blue node)
 *   idle    → yellow-600      (#ca8a04 — amber idle node)
 *
 * Import from here instead of hard-coding hex strings so theme updates land
 * in one place.
 */
export const NODE_COLOR_ACTION = "#22c55e"; // Tailwind green-500 — green action node
export const NODE_COLOR_TRIGGER = "#2450ff"; // ds-focus-brand — blue trigger node
export const NODE_COLOR_IDLE = "#ca8a04"; // Tailwind yellow-600 — amber idle node
